import { useEffect, type RefObject } from 'react'

type CurrentTimeLineProps = {
  currentLineRef: RefObject<HTMLDivElement>
  currentLinePosition: number
  onScrollToLine: () => void
}

const CurrentTimeLine = ({
  currentLineRef,
  currentLinePosition,
  onScrollToLine,
}: CurrentTimeLineProps) => {
  useEffect(() => {
    onScrollToLine()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentLineRef.current])

  return (
    <div
      className='current-time-line absolute left-0 h-0.5 w-full bg-red-700'
      ref={currentLineRef}
      style={{
        top: `calc(${String(currentLinePosition)}% + 7px)`,
      }}
    />
  )
}

export default CurrentTimeLine
